import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Levels"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "List of levels")
], -1)
const _hoisted_3 = {
  class: "card-toolbar",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-trigger": "hover",
  title: "Click to add a new level"
}
const _hoisted_4 = { class: "svg-icon svg-icon-3" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add new Level ")
const _hoisted_6 = { class: "card-body py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelModal = _resolveComponent("LevelModal")!
  const _component_DeleteModal = _resolveComponent("DeleteModal")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_LevelsDataTable = _resolveComponent("LevelsDataTable")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _withDirectives(_createVNode(_component_LevelModal, {
      currentlySelectedLevel: _ctx.currentlySelectedLevel,
      title: _ctx.modalSetup.title,
      action: _ctx.modalSetup.action,
      onSaveChanges: _ctx.saveDataFromModal
    }, null, 8, ["currentlySelectedLevel", "title", "action", "onSaveChanges"]), [
      [_vShow, _ctx.isThereAModalActive]
    ]),
    _withDirectives(_createVNode(_component_DeleteModal, {
      onDelete: _ctx.deleteSelectedLevel,
      currentlySelectedEntry: this.currentlySelectedLevel.name
    }, null, 8, ["onDelete", "currentlySelectedEntry"]), [
      [_vShow, _ctx.isThereAModalActive]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openAddNewModal && _ctx.openAddNewModal(...args)), ["prevent"])),
          href: "#",
          class: "btn btn-sm btn-success",
          "data-bs-toggle": "modal",
          "data-bs-target": "#LevelModal"
        }, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Plus.svg" })
          ]),
          _hoisted_5
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
        : (_ctx.getData.length == 0)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              description: 'OOPS... Unfortunately no levels were found.'
            }, null, 8, ["description"]))
          : (_openBlock(), _createBlock(_component_LevelsDataTable, {
              key: 2,
              ref: "levelDataTable",
              tableData: _ctx.getData,
              onEditModalOpened: _ctx.openEditModal,
              onDeleteModalOpened: _ctx.openDeleteModal,
              onSaveWeights: _ctx.handleSaveWeight
            }, null, 8, ["tableData", "onEditModalOpened", "onDeleteModalOpened", "onSaveWeights"]))
    ])
  ], 2))
}